import { render, staticRenderFns } from "./NameConflicts.vue?vue&type=template&id=20ac892a&"
import script from "./NameConflicts.vue?vue&type=script&lang=js&"
export * from "./NameConflicts.vue?vue&type=script&lang=js&"
import style0 from "./NameConflicts.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports